var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("label", { staticClass: "contactum-label" }, [
        _vm._v(_vm._s("Dynamic Value"))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.dynamic.status,
            expression: "dynamic.status"
          }
        ],
        attrs: { type: "checkbox", value: "yes" },
        domProps: {
          checked: Array.isArray(_vm.dynamic.status)
            ? _vm._i(_vm.dynamic.status, "yes") > -1
            : _vm.dynamic.status
        },
        on: {
          change: function($event) {
            var $$a = _vm.dynamic.status,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = "yes",
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && _vm.$set(_vm.dynamic, "status", $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  _vm.$set(
                    _vm.dynamic,
                    "status",
                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                  )
              }
            } else {
              _vm.$set(_vm.dynamic, "status", $$c)
            }
          }
        }
      }),
      _vm._v(" "),
      _vm.editfield.dynamic
        ? [
            _c("label", [_vm._v(_vm._s("Parameter Name"))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.param_name,
                  expression: "param_name"
                }
              ],
              attrs: { type: "text" },
              domProps: { value: _vm.param_name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.param_name = $event.target.value
                }
              }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }